// src/services/userService.ts - VERSIONE FINALE E AUTOMATICA

// 1. Usiamo il nostro apiClient centralizzato
import apiClient from './apiClient';
import { User } from '../types/user';

// Interfacce per i dati, le teniamo perché sono utili
interface UsersResponse {
  users: User[];
  total: number;
  pages: number;
  current_page: number;
  per_page: number;
}

interface CreateUserData {
  email: string;
  password: string;
  name: string;
  role: 'ADMIN' | 'USER';
}

interface UpdateUserData {
  email?: string;
  name?: string;
  role?: 'ADMIN' | 'USER';
  is_active?: boolean;
}

class UserService {
  // 2. Tutte le chiamate ora usano apiClient e percorsi relativi.
  //    Non serve più la costante API_URL.
  //    L'autenticazione è gestita in automatico.

  async getUsers(page: number = 1, perPage: number = 10): Promise<UsersResponse> {
    const response = await apiClient.get('/api/users/', {
      params: { page, per_page: perPage },
    });
    return response.data;
  }

  async getUser(userId: number): Promise<User> {
    const response = await apiClient.get(`/api/users/${userId}`);
    return response.data.user;
  }

  // Nota: questa potrebbe essere una rotta pubblica, ma usare apiClient non crea problemi.
  async createUser(userData: CreateUserData): Promise<User> {
    const response = await apiClient.post('/api/auth/register', userData);
    return response.data.user;
  }

  async updateUser(userId: number, userData: UpdateUserData): Promise<User> {
    const response = await apiClient.put(`/api/users/${userId}`, userData);
    return response.data.user;
  }

  async deleteUser(userId: number): Promise<void> {
    await apiClient.delete(`/api/users/${userId}`);
  }

  async changePassword(
    userId: number,
    currentPassword?: string,
    newPassword?: string
  ): Promise<void> {
    const data: any = { new_password: newPassword };
    if (currentPassword) {
      data.current_password = currentPassword;
    }
    
    await apiClient.post(`/api/users/${userId}/change-password`, data);
  }
}

export const userService = new UserService();